import { useContext } from "react"
import { Modal, ModalContent, } from "semantic-ui-react"
import { UiComponentContext } from "./MissionWorkflowComponent";
// Builds component of a button
export const ModalComponent = () => {
    const { uiComponent } = useContext(UiComponentContext);

    function showUiModal() {
        if (uiComponent) {
            return true
        } else {
            return false
        }
    }

    return (
        <>
            <Modal open={ showUiModal() }>
                <ModalContent>
                    {uiComponent}
                </ModalContent>
            </Modal>
        </>
    );

}